/**
 * Features — full features grid + how-it-works strip on its own page.
 */
import React from 'react';
import MarketingLayout from './MarketingLayout';
import Section from './components/Section';
import FeatureCard from './components/FeatureCard';
import CTABand from './components/CTABand';
import useSiteConfig from './useSiteConfig';
import { COLOR, FONT, RADIUS } from '../../components/ss/tokens';

export default function Features() {
  const { config } = useSiteConfig();
  const { features, howItWorks } = config;
  const fb = config.ui?.fallbacks || {};
  const stepLabel = config.ui?.stepLabel || 'STEP';

  return (
    <MarketingLayout>
      {features?.items?.length > 0 && (
        <Section
          background="#fff"
          paddingY={88}
          eyebrow={features.eyebrow || fb.featuresEyebrow}
          title={features.title || fb.featuresTitle}
          subtitle={features.subtitle}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
              gap: 20,
            }}
          >
            {features.items.map((f, i) => (
              <FeatureCard key={i} icon={f.icon} title={f.title} body={f.body} />
            ))}
          </div>
        </Section>
      )}

      {howItWorks?.steps?.length > 0 && (
        <Section
          background={COLOR.grayBg}
          eyebrow={howItWorks.eyebrow}
          title={howItWorks.title}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: 20,
            }}
          >
            {howItWorks.steps.map((s, i) => (
              <div
                key={i}
                style={{
                  background: '#fff',
                  border: `1px solid ${COLOR.grayBorder}`,
                  borderRadius: RADIUS.lg,
                  padding: 24,
                }}
              >
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: FONT.weight.bold,
                    color: COLOR.blue,
                    letterSpacing: '2px',
                  }}
                >
                  {stepLabel} {s.number}
                </div>
                <h3 style={{ margin: '8px 0 10px', fontSize: 18, fontWeight: FONT.weight.bold, color: COLOR.text }}>
                  {s.title}
                </h3>
                <p style={{ margin: 0, fontSize: FONT.size.md, lineHeight: 1.6, color: COLOR.textMuted }}>
                  {s.body}
                </p>
              </div>
            ))}
          </div>
        </Section>
      )}

      <CTABand />
    </MarketingLayout>
  );
}
